import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const SignOut = () => {
  const { logout } = useAuth();
  const nav = useNavigate();
  return (
    <button className="btn g sm" data-testid="sign-out-button" onClick={async () => { await logout(); nav("/login", { replace: true }); }}>
      Sign out
    </button>
  );
};
